// helper function to deal with having both Promises and jQuery Deferreds
// in our codebase
export function getErrorMessage(error) {
  return (
    error.message ||
    (error.responseJSON && error.responseJSON.message) ||
    'Something went wrong. Please try again.'
  )
}
